// react-native-fs stub for web
export const DocumentDirectoryPath = '/documents';
export const CachesDirectoryPath = '/caches';

const RNFS = {
  DocumentDirectoryPath,
  CachesDirectoryPath,
  readFile: async () => '',
  writeFile: async () => {},
  exists: async () => false,
  mkdir: async () => {},
  unlink: async () => {},
  readDir: async () => [],
  copyFile: async () => {},
  moveFile: async () => {},
  stat: async () => ({size: 0, isFile: () => true, isDirectory: () => false}),
};

export default RNFS;
